exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-panel-column {\n    width: 20%;\n}\n\n.bundle-list-input-column {\n    width: 15%;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/product/bundle/styles/BundleItemsListStyles.css
// module id = 6069
// module chunks = 0